// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"DN-z","carouselContainer":"EN-z"};